/* @ngInject */

export default (
  $q,
  helperService,
  applicationFormPdfService,
  privacyDisclosureStatementService,
  homeLoanFundingWorksheetPdfService,
  homeLoanMaximumBorrowingPdfService,
  homeLoanCompareProductsPdfService,
  homeLoanRefinanceAnalysisPdfService,
  homeLoanFeesAndChargesPdfService,
  assetFinanceAmortizationSchedulePdfService,
  assetFinanceCompareProductsPdfService
) => {
  /**
   * Create PDF.
   *
   * @param {Array} contacts
   * @param {Array} contactLabels
   * @param {Array} lenders
   * @param {Array} documents
   * @param {Object} ticket
   * @param {Object} ticketOwner
   * @param {Object} loan
   * @param {Object} workflow
   * @param {Array} compareProducts
   * @param {Array} reviewProducts
   * @param {Object} searchFields
   * @param {Object} maximumBorrowing
   * @param {Array} filteredLenders
   * @param {Array} spouses
   * @param {Object} financeProposal
   * @param {Number} settlementDate
   * @param {String} pdfType
   * @param {Boolean} isQuickTool
   * @param {Boolean} isView
   *
   * @returns {Object}
   */
  const createPdf = ({
    contacts,
    contactLabels,
    lenders,
    documents,
    ticket,
    ticketOwner,
    loan,
    workflow,
    fundingWorksheets,
    homeLoanSecurities,
    compareProducts,
    reviewProducts,
    refinanceAnalysis,
    searchFields,
    maximumBorrowing,
    filteredLenders,
    spouses,
    financeProposal,
    settlementDate,
    pdfType,
    isCommercial,
    isQuickTool,
    isView
  }) => {
    const deferred = $q.defer();
    const pdfTypes = helperService.getAvailablePdfTypes();
    if (pdfType === pdfTypes[0]) {
      applicationFormPdfService
        .createApplicationForm({
          contacts,
          contactLabels,
          lenders,
          ticket,
          ticketOwner,
          loan,
          workflow,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[1]) {
      privacyDisclosureStatementService
        .createPrivacyDisclosureStatement({
          contacts,
          contactLabels,
          ticket,
          ticketOwner,
          workflow,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[2]) {
      homeLoanFundingWorksheetPdfService
        .createHomeLoanFundingWorksheet({
          fundingWorksheets,
          homeLoanSecurities,
          ticket,
          isQuickTool,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[3]) {
      homeLoanMaximumBorrowingPdfService
        .createHomeLoanMaximumBorrowing({
          maximumBorrowing,
          lenders,
          filteredLenders,
          documents,
          contacts,
          spouses,
          ticket,
          isQuickTool,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[4]) {
      homeLoanCompareProductsPdfService
        .createHomeLoanCompareProducts({
          compareProducts,
          reviewProducts,
          lenders,
          documents,
          fundingWorksheets,
          searchFields,
          ticket,
          isQuickTool,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[5]) {
      homeLoanRefinanceAnalysisPdfService
        .createHomeLoanRefinanceAnalysis({
          refinanceAnalysis,
          ticket,
          isQuickTool,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[6]) {
      homeLoanFeesAndChargesPdfService
        .createHomeLoanFeesAndCharges({
          contacts,
          contactLabels,
          ticket,
          ticketOwner,
          loan,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[7]) {
      assetFinanceAmortizationSchedulePdfService
        .createAssetFinanceAmortizationSchedule({
          contacts,
          financeProposal,
          ticket,
          settlementDate,
          isCommercial,
          isQuickTool,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    if (pdfType === pdfTypes[8]) {
      assetFinanceCompareProductsPdfService
        .createAssetFinanceCompareProducts({
          assetDetails: loan?.assetDetails || [],
          compareProducts: loan?.compareProducts || [],
          lenders,
          documents,
          ticket,
          isCommercial: loan?.isCommercial,
          isQuickTool,
          isView
        })
        .then(() => {
          deferred.resolve();
        });
    }
    return deferred.promise;
  };

  return {
    createPdf
  };
};
